import { useState } from "react";
import { Button, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./DropdownFilterWrapper.scss";

interface DropdownFilterWrapperProps {
  children: React.ReactNode;
  btnText: string;
  btnIcon: any;
  title?: string;
  subtitle?: string;
  onClear?: () => void;
  onFilter?: () => void;
}

const DropdownFilterWrapper = (props: DropdownFilterWrapperProps) => {
  const { children, btnText, btnIcon, title, subtitle, onClear, onFilter } =
    props;
  const [open, setOpen] = useState(false);

  const showHeader = title || subtitle;

  const onClickClear = async () => {
    if (onClear) {
      await onClear();
    }
  };

  const onClickFilter = async () => {
    if (onFilter) {
      await onFilter();
    }
    setOpen(false);
  };

  return (
    <Dropdown
      className="dropdown-filter-wrapper-container"
      trigger={["click"]}
      open={open}
      onOpenChange={setOpen}
      popupRender={() => (
        <div className="dropdown-filter-wrapper">
          <div className="dropdown-header" hidden={!showHeader}>
            <p className="dropdown-header-title">{title}</p>
            <p className="dropdown-header-description">{subtitle}</p>
          </div>
          <div className="dropdown-body">{children}</div>
          <div className="dropdown-footer">
            <Button type="link" className="clear-button" onClick={onClickClear}>
              Clear filter
            </Button>
            <Button
              type="primary"
              className="apply-button"
              onClick={onClickFilter}
            >
              Apply filter
            </Button>
          </div>
        </div>
      )}
    >
      <Button className="dropdown-filter-wrapper-button">
        <FontAwesomeIcon icon={btnIcon} />
        {btnText} <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default DropdownFilterWrapper;
